import type { TLiveAvatarOption } from "@/types/TLiveAvatarOption";
import { authenticatedFetchJson } from "@/services/utils/authenticatedFetch";

interface AvatarsApiResponse {
  code: number;
  data: {
    count: number;
    results: TLiveAvatarOption[];
  };
}

export async function fetchAvailableAvatars(): Promise<TLiveAvatarOption[]> {
  try {
    const response = await authenticatedFetchJson<AvatarsApiResponse>("/api/heygen/avatars_v2");
    return response?.data?.results ?? [];
  } catch (error) {
    console.error("[fetchAvailableAvatars] Error:", error);
    throw error;
  }
}
